import { createAsyncThunk } from '@reduxjs/toolkit';
import { MyInvestmentsService } from 'api';

export const loadInvestment = createAsyncThunk(
	'myInvestments/loadInvestment',
	async (id: number) => {
		return await MyInvestmentsService.getInvestment(id);
	},
);
